import { CheckBadgeIcon } from '@heroicons/react/20/solid';
import { FunctionComponent } from 'react';

/**
 *
 */
export const EmailVerifie: FunctionComponent = () => <CheckBadgeIcon className='w-4 h-4 text-light-green-300 ml-1 mt-1' title='Email vérifié' />;
